import {
    Authenticator,
    SignIn,
    SignUp,
    SignOut,
    ConfirmSignUp,
    ConfirmSignIn,
    ForgotPassword,
    SetMfa,
    //Chatbot,
    //PhotoPicker,
    //S3Album,
    //S3Image,
    SumerianScene,
    RequireNewPassword,
    //Connect
} from './components';
import AmplifyPlugin from './plugins/AmplifyPlugin';
import AmplifyEventBus from './events/AmplifyEventBus';
import '@aws-amplify/ui/dist/style.css'

export {
    Authenticator,
    SignIn,
    SignUp,
    SignOut,
    ConfirmSignUp,
    ConfirmSignIn,
    ForgotPassword,
    SetMfa,
    //Chatbot,
    //PhotoPicker,
    //S3Album,
    //S3Image,
    //SumerianScene,
    RequireNewPassword,
    //Connect,
    AmplifyPlugin,
    AmplifyEventBus,
}